<template>
  <Chip
    icon="fas fa-person-booth text-white mt-1"
    :label="name"
    class="mb-1 px-2 CustomScopeIdeaBadge text-xs font-weight-normal text-truncate"
    style="margin-top: 0.1rem; height: 2ch; color: white"
    :pt="{
      root: {
        style: { backgroundColor: variant },
      },
    }"
  />
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import Chip from "primevue/chip";
import { IdeaRecommend, IdeaVeto, type ActionListActionFields_Task_Fragment } from "@/graphql";

export default defineComponent({
  name: "IdeaBadge",
  components: {
    Chip,
  },
  props: {
    taskMeta: {
      type: Object as PropType<ActionListActionFields_Task_Fragment["meta"]>,
      required: true,
    },
  },
  setup(props) {
    const { t } = useTranslation();
    const name = computed(() => {
      switch (props.taskMeta?.__typename) {
        case "IdeaIdeaTaskMeta":
          return t(`components.TaskModal.idea.${props.taskMeta.veto}`);
        case "IdeaManageTaskMeta":
          return t(`components.TaskModal.idea.${props.taskMeta.recommend}`);
        default:
          throw Error("wrong idea meta type");
      }
    });

    const variant = computed(() => {
      switch (props.taskMeta?.__typename) {
        case "IdeaIdeaTaskMeta":
          switch (props.taskMeta.veto) {
            case IdeaVeto.veto:
              return "var(--p-danger-color)";
            case IdeaVeto.noVeto:
              return "var(--p-success-color)";
            case IdeaVeto.nothing:
              return "var(--p-secondary-color)";
            default:
              throw Error("unknown veto type");
          }
        case "IdeaManageTaskMeta":
          switch (props.taskMeta.recommend) {
            case IdeaRecommend.recommend:
              return "var(--p-success-color)";
            case IdeaRecommend.recommendNot:
              return "var(--p-danger-color)";
            case IdeaRecommend.recommendNotPossible:
              return "var(--p-primary-color)";
            case IdeaRecommend.nothing:
              return "var(--p-secondary-color)";
            default:
              throw Error("unknown veto type");
          }
        default:
          throw Error("wrong idea meta type");
      }
    });

    return { name, variant };
  },
});
</script>

<style lang="scss">
.CustomScopeIdeaBadge {
  &.primary .p-chip.custom-chip {
    background: var(--p-primary-color);
    color: var(--p-primary-contrast-color);
  }
  &.secondary .p-chip.custom-chip {
    background: var(--p-secondary-color);
    color: var(--p-primary-contrast-color);
  }
  &.danger .p-chip.custom-chip {
    background: var(--p-danger-color);
    color: var(--p-primary-contrast-color);
  }
  &.success .p-chip.custom-chip {
    background: var(--p-success-color);
    color: var(--p-primary-contrast-color);
  }

  .p-chip-text {
    font-size: 0.8335em;
    margin: 0;
  }
}
</style>

<style lang="scss" scoped></style>
